import { z } from "zod";

export const surveyInterventionDtoSchema = z.object({
  endDatetime: z.coerce.date(),
  endReasonId: z.number(),
  endReasonNote: z.string(),
  interventionId: z.number(),
  startDatetime: z.coerce.date(),
});

export type TSurveyInterventionDto = z.infer<typeof surveyInterventionDtoSchema>;
